export default __webpack_public_path__ + "static/media/TX_Elemental_Wind_Grimory.0b75f93e.png";